// Mirrors the backend's `ROLE_ALIASES` (see server.py `require_role`) so
// frontend action-button visibility matches what the API will actually
// accept. Without this, a page's hardcoded `["admin","planner"].includes(role)`
// check silently drifted from the backend's role check (which also honors
// these aliases), hiding buttons — Edit / Raise DC / Create Packing Slip,
// Dispatch, Cancel, etc. — for roles the API happily allows, e.g. a
// "sales_crm" user (aliased to "planner") could always Raise a DC via the
// API but never saw the button for it.
const ROLE_ALIASES = {
  production_manager: ["planner", "operator", "routing"],
  quality_inspector: ["quality"],
  store_manager: ["stores"],
  sales_crm: ["planner"],
  purchase_manager: ["stores"],
  purchase_executive: ["stores"],
  sales_manager: ["planner"],
  sales_executive: ["planner"],
};

// True when `role` is in `allowed`, or aliases to a role that is.
export function roleAllowed(role, allowed) {
  if (!role) return false;
  if (allowed.includes(role)) return true;
  const aliases = ROLE_ALIASES[role];
  return !!aliases && aliases.some((a) => allowed.includes(a));
}
